import { render, staticRenderFns } from "./ApiControl.vue?vue&type=template&id=5886ba4b&scoped=true&"
import script from "./ApiControl.vue?vue&type=script&lang=js&"
export * from "./ApiControl.vue?vue&type=script&lang=js&"
import style0 from "./ApiControl.vue?vue&type=style&index=0&id=5886ba4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5886ba4b",
  null
  
)

export default component.exports